export const MAX_AVATAR_BYTES = 5 * 1024 * 1024;
export const AVATAR_ACCEPT = 'image/jpeg,image/png,image/webp,image/gif';

const ALLOWED_AVATAR_TYPES = new Set(AVATAR_ACCEPT.split(','));

export function validateAvatarFile(file: Pick<File, 'type' | 'size'>): string | null {
  if (!ALLOWED_AVATAR_TYPES.has(file.type)) {
    return 'Choose a JPEG, PNG, WebP, or GIF image.';
  }
  if (file.size <= 0 || file.size > MAX_AVATAR_BYTES) {
    return 'Avatar must be between 1 byte and 5 MB.';
  }
  return null;
}

export function canEditOwnAvatar(
  viewedEmployeeId: string | undefined,
  currentEmployeeId: string | null | undefined,
): boolean {
  return Boolean(
    viewedEmployeeId
    && currentEmployeeId
    && viewedEmployeeId === currentEmployeeId,
  );
}
